import { Link, useOutletContext } from "react-router-dom";
import { Home, WifiOff, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

function Offline() {
  const context = useOutletContext();
  const isDark = context?.isDark ?? true;

  return (
    <div className="min-h-screen flex items-center justify-center py-12">
      <div className="max-w-lg mx-auto px-4 text-center">
        {/* Icon */}
        <div className="flex justify-center mb-6">
          <div className={`rounded-full p-6 ${isDark ? 'bg-white/5' : 'bg-slate-100'}`}>
            <WifiOff className={`h-16 w-16 ${isDark ? 'text-white/30' : 'text-slate-300'}`} />
          </div>
        </div>

        {/* Message */}
        <h2 className={`text-2xl md:text-3xl font-bold font-['Chivo'] mb-4 ${isDark ? 'text-white' : 'text-slate-900'}`}>
          Geen internetverbinding
        </h2>
        <p className={`mb-8 ${isDark ? 'text-slate-400' : 'text-slate-600'}`}>
          Het lijkt erop dat je geen internetverbinding hebt. Controleer je verbinding en probeer het opnieuw.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button 
            onClick={() => window.location.reload()} 
            className="bg-[hsl(48,96%,53%)] hover:bg-[hsl(48,96%,43%)] text-black font-semibold"
          >
            <RefreshCw className="h-4 w-4 mr-2" />
            Opnieuw proberen
          </Button>
          <Button asChild variant="outline" className={isDark ? 'border-white/20 text-white hover:bg-white/10' : ''}>
            <Link to="/">
              <Home className="h-4 w-4 mr-2" />
              Naar homepagina
            </Link>
          </Button>
        </div>
      </div>
    </div>
  );
}

export default Offline;
